import { Immutable } from "immer";
import React from "react";
import { useFlickity } from "tsi-common-react/src/hooks/useFlickity";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type ICategory = templates.ProductListPageTemplate["categories"][number];

type IProps = Immutable<{
    categories: ICategory[];
}>;

// The category jump-nav is a Flickity carousel on mobile only (activated via
// `watchCSS` against the list's `::after { content: "flickity" }` in the module).
// Flickity is initialized in an effect (post-hydration) rather than as a
// module-load side effect: on a full-document React page React owns this <ul>,
// so mutating it before hydrateRoot() would trigger a hydration mismatch and
// React would discard the carousel.
export const ProductListNav = (props: IProps): React.JSX.Element => {
    const listRef = React.useRef<HTMLUListElement>(null);
    useFlickity(listRef, {
        options: {
            watchCSS: true,
            draggable: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: true,
        },
        enabled: props.categories.length > 0,
    });

    return (
        <nav className={styles.productListNav}>
            <ul
                ref={listRef}
                className={concatClassNames([
                    styles.productListNavList,
                    "l-capped-width",
                ])}
            >
                {props.categories.map((category, i) => (
                    <li key={i} className={styles.productListNavItem}>
                        <a
                            href={`#${category.title}`}
                            className="product-list-nav__link"
                        >
                            {category.title}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
